import { TServiceName } from '@frontstoreRwd/modules/analytics/services/types';

export const GTM_TRACKING_TYPE = '1';
export const NATIVE_TRACKING_TYPE = '0';

export const CAMPAIGN_GOOGLE_ANALYTICS_V4 = {
    layerName: 'campaignLayer',
    serviceName: 'GoogleAnalyticsV4GtagCampaign' as TServiceName
};
